import { AiOutlineCloseSquare } from "react-icons/ai";

export const alertWarningStyle = {
  style: {
    background: "var(--orange)",
    color: "white",
  },
  progressStyle: {
    background: "white",
  },
  icon: AiOutlineCloseSquare,
};
